
import { Component, Prop, Vue } from 'vue-property-decorator'
import { productDate } from '@/helpers/date'

@Component({
  components: {},
})
export default class ProductTemplate extends Vue {
  @Prop() readonly product
  @Prop() readonly total_products_sold_type
  @Prop() selectProductAndOpenModal
  @Prop() copyToClipboard
  @Prop() sellerCode
  @Prop() canEditProducts
  @Prop({ type: Boolean, default: false }) readonly hideShareLinkButton!: boolean

  showSellers = false

  dateToHours(isoDate) {
    return productDate(isoDate)
  }

  getFriendlyPaymentMethod(method) {
    if (!method) return ''

    // Soporte para strings tipo '["mp","bind"]'
    if (typeof method === 'string' && method.trim().startsWith('[')) {
      try {
        method = JSON.parse(method)
      } catch {
        // en caso de error, continuamos con la lógica normal
      }
    }

    const methods = Array.isArray(method)
      ? method
      : typeof method === 'string' && method.includes(',')
      ? method.split(',')
      : [method]

    const map = {
      mp: 'Mercado Pago',
      mcp: 'Macro Click',
      bind: 'Transferencia',
    }

    return methods
      .map((m) => map[m.trim()])
      .filter(Boolean)
      .join(' / ')
  }

  goToEditProduct(productId, step) {
    window.location.href =
      process.env.VUE_APP_ADMIN_DOMAIN +
      '/products/edit/' +
      productId +
      (step ? '?step=' + step + '&' : '?') +
      'jwt=' +
      localStorage.getItem('access_token')
  }

  ocupate(totalTicket) {
    return totalTicket || 0
  }

  goToProductTickets(id) {
    this.$router.push({
      name: 'all-links',
      query: {
        productId: id,
      },
    })
  }

  async shareProduct(productUuid: string) {
    this.$router.push(`/generate-exlusive-ticket/${productUuid}`)
  }

  sharePromotionalProduct(productUuid: string) {
    const textToCopy = process.env.VUE_APP_DOMAIN_ECOMMERCE + '/buy-product/' + productUuid + '?code=' + this.sellerCode

    navigator.clipboard.writeText(textToCopy).then(
        function() {
          Vue.$toast.success(`Link del producto copiado!`)
        },
        function(err) {
          Vue.$toast.error(`Error copiando mensaje! Intenta nuevamente`)
        }
      )
  }
}
